import {svgIconWrapper} from '../svg-icon-wrapper';

import TrelloRegular from './trello-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <TrelloRegular {...rest} />;
}

SvgComponent.iconName = 'trelloRegular';

export const TrelloRegularIcon = svgIconWrapper(SvgComponent);
